class Checkbox
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'checkbox--bound'
            @.$errorEl = @.$el.querySelector '.checkbox__error'
            @.$inputEl = @.$el.querySelector 'input[type="checkbox"]'

            @.error = @.$el.classList.contains 'checkbox--error'
            @.required = @.$el.classList.contains 'checkbox--required'
            @.requiredText = @.$el.dataset?.requiredText ? 'Dieses Option muss ausgewählt werden.'

            @.$el.classList.add 'checkbox--bound'
            @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'checkbox-set-error', (e) ->
            error = e.detail?.showError ? false
            errorText = e.detail?.errorText ? self.requiredText
            if error
                self.SetError errorText
            else
                self.SetError false
            return
        @.$el.addEventListener 'checkbox-reset', (e) ->
            self.Reset()
            return
        @.$inputEl.addEventListener 'change', (e) ->
            if @.checked
                self.SetError false
            else
                if @.required
                    self.SetError self.requiredText
            return
        return
    
    Reset: ->
        @.$inputEl.checked = false
        @.SetError false
        return
    
    SetError: (error) ->
        if error
            @.$errorEl.innerHTML = error
            @.error = true
            @.$el.classList.add 'checkbox--error'
        else
            @.$errorEl.innerHTML = ""
            @.error = false
            @.$el.classList.remove 'checkbox--error'
        return
    
BindCheckboxes = ->
    document.querySelectorAll '.checkbox:not(.checkbox--bound)'
        .forEach (el) ->
            new Checkbox el
            return
    return

window.addEventListener 'bind-components', BindCheckboxes